import React from 'react'
import {
  LatestShareVersionSubscribe,
  useVersioning,
} from '../ShareVersionContext'
import { useVersionHistoryQuery } from '../operations'
import { ShareVersionSwitcher } from './ShareVersionSwitcher'

const ShareVersionSwitcherQuery = () => {
  const {
    versionShortId,
    share,
    isViewingLatestVersion,
    isLibrary,
  } = useVersioning()
  const versionsData = useVersionHistoryQuery(
    share.identifier,
    share.versionTypeAvailableToUser
  )

  if (!versionsData) return null

  const {
    entries,
    totalCount,
    loadLatestHandler,
    loadMoreHandler,
  } = versionsData

  return (
    <>
      <LatestShareVersionSubscribe
        onVersionUpdate={loadLatestHandler}
        shareID={share.identifier}
      />
      <ShareVersionSwitcher
        shareIdentifier={share.identifier}
        entries={entries}
        totalCount={totalCount!}
        versionShortId={versionShortId}
        onLoadMore={loadMoreHandler!}
        onLoadLatest={loadLatestHandler!}
        shareName={share.name}
        isViewingLatestVersion={isViewingLatestVersion}
        isLibrary={isLibrary}
        canEdit={share.userCanContribute}
      />
    </>
  )
}

export default ShareVersionSwitcherQuery
